import { schema } from 'normalizr';
import {
  LocalizableString,
} from '../cms/common/types';

export interface Choice {
  id: string;
  choicesText: LocalizableString;
  subQuestions: Array<Question>;
}

export interface Question {
  id: string;
  questionText: LocalizableString;
  choices: Array<Choice>;
  queryField: string;
}

export const questionEntity = new schema.Entity('questions', {}, {});
